import Anchor from 'containers/ac-containers/ac-anchor';
import { useTranslation } from 'hooks/use-translation';
import { useModalContext } from 'hooks/useModalContext';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { HowMuchSection, OnlyPaySection, RiskSection, CommentsSection, SessionSection, FaqsSection } from './components';
import styles from './styles.scss';


export default function TutorsPage(props: { location: any }) {
	const { setTrigger, setEvent } = useModalContext()
	const anchor = useHistory().location.hash;
	const { transData } = useTranslation('home');

	useEffect(() => {
		if (!anchor) {
			window.scrollTo(0, 0);
		}
	}, []);


	function handleClick() {
		setTrigger(true);
		setEvent({ eventId: '' });
	}

	return (
		<div className={styles['ac-container']}>
			<main className={styles['ac-prices']}>
				<SessionSection onClick={handleClick} id="session" />
				<HowMuchSection />
				<OnlyPaySection />
				<RiskSection />
				<CommentsSection />
				<FaqsSection />
				<Anchor className={styles.anchor} anchorText={'session'} eventId="PAG_94b2e816f60188a4">
					<img src={transData.toTop} alt="" />
				</Anchor>
			</main>
		</div>
	);
}
